import { ProjectStatus } from '../../common/project-status';
import { StormDoorColor } from '../../common/storm-door-color';
import { IAppliedDiscount, AppliedDiscount } from '../../common/applied-discount';
import { IInstallationSiteModel, InstallationSiteModel } from './installation-site-model';
import { IStormDoorColorOption, StormDoorColorOption } from '../../common/storm-door-color-option';

export interface IProjectConfiguration {
    status: ProjectStatus;
    myName: string;
    stormDoorColorPreferences: StormDoorColor[];
    subtotal: number;
    discounts: IAppliedDiscount[];
    isTaxExempt: boolean;
    tax: number;
    total: number;
    installLocations: IInstallationSiteModel[];
    paymentProcessorClientId: string;
    stormDoorColorOptions: IStormDoorColorOption[];
}


export class ProjectConfiguration implements IProjectConfiguration {
    public status: ProjectStatus = ProjectStatus.Indeterminate;
    public myName: string = '';
    public stormDoorColorPreferences: StormDoorColor[] = [];
    public subtotal: number = 0;
    public discounts: IAppliedDiscount[] = [];
    public isTaxExempt: boolean = false;
    public tax: number = 0;
    public total: number = 0;
    public installLocations: IInstallationSiteModel[] = [];
    public paymentProcessorClientId: string = '';
    public stormDoorColorOptions: IStormDoorColorOption[] = [];
}


